import { ReactComponent as ArrowIcon } from "@web-src/images/icons/arrow-left.svg";
import { ReactNode } from "react";
import ToolbarSubmitButton from "./ToolbarSubmitButton";
import useEditorContext from "../useEditorContext";
import PreviewTool from "../../tools/PreviewTool";

interface ComponentProps {
  children: ReactNode;
}

const BackButton = () => {
  const { instance, setActiveTool } = useEditorContext();

  return (
    <button
      type="button"
      className="h-10 w-10 cursor-pointer border-none bg-transparent text-white"
      onClick={() => {
        setActiveTool("preview", new PreviewTool(instance?.canvas ?? null));
        instance?.dispose();
      }}
    >
      <ArrowIcon />
    </button>
  );
};

const ToolbarActionWrapper = ({ children }: ComponentProps) => (
  <div className="hidden w-full items-center justify-between gap-6 sm:flex sm:gap-10 lg:gap-20">
    <BackButton />

    {children}

    <ToolbarSubmitButton />
  </div>
);

export default ToolbarActionWrapper;
